const exports = {
  brandColors: {
    brand_5: '#FFF3F2',
    brand_10: '#FED1CD',
    brand_20: '#FDADA8',
    brand_30: '#FC8985',
    brand_40: '#FB6561',
    brand_50: '#EF2D2B',
    brand_55: '#E20000' /* brand*/,
    brand_60: '#C00500',
    brand_65: '#9E0900',
    brand_70: '#7C0A00',
    brand_80: '#5B0900',
    brand_90: '#390700',
    brand_100: '#170400',
  },
  sport: {
    sport_5: '#F5FFFA',
    sport_10: '#CCF3D9',
    sport_20: '#A7E7B0',
    sport_30: '#87DB85',
    sport_40: '#7BCF65',
    sport_50: '#68B83A',
    sport_55: '#62A01A' /* brand*/,
    sport_60: '#3B8910',
    sport_65: '#1D710B',
    sport_70: '#085A08',
    sport_80: '#064311',
    sport_90: '#052C13',
    sport_100: '#03140C',
  },
  blicktvGrey: {
    btvGrey_5: '#F9FBFF',
    btvGrey_10: '#F3F8FE',
    btvGrey_20: '#E7F0FE',
    btvGrey_30: '#D2E0F2',
    btvGrey_40: '#B2C1D4',
    btvGrey_45: '#8796A6',
    btvGrey_50: '#616C77',
    btvGrey_55: '#46505A',
    btvGrey_60: '#2E363D' /* darkGrey*/,
    btvGrey_70: '#1C1E21',
    btvGrey_80: '#101012',
    btvGrey_90: '#080808',
    btvGrey_100: '#000000',
  },

  blicktvGradients: {
    radialRed:
      'radial-gradient(100% 100% at 100% 100%, #98021C 0%, #1C1E21 100%)',
  },

  white: '#FFFFFF',

  grey: {
    grey_10: '#F8F8F8',
    grey_20: '#EEEEEE',
    grey_30: '#E0E0E0',
    grey_50: '#C8C8C8',
    grey_60: '#A9A9A9',
    grey_70: '#8E8E90',
    grey_75: '#767676',
    grey_80: '#545454',
    grey_90: '#3D3D3D',
    grey_100: '#1F1F1F',
  },

  page: {
    inverted: '#000000',
  },

  secondary: {
    error: '#F8E71C',
    focus: '#2460C5',
    star_yellow: '#FFCE00',
  },

  lotto: {
    lottoJackpot: '#D6081C',
    lottoLucky: '#F8E71C',
  },
}

export default exports
